import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG.client";
import { ButtonTypes } from "./Button";
import animationStyles from "./AnimationButton.module.scss";

type ButtonIconsProps = {
  type: ButtonTypes;
  isDownload: boolean;
};

/** Leading/trailing icons rendered inside both the link and button variants of Button */
export const ButtonIcons = ({ type, isDownload }: ButtonIconsProps) => (
  <>
    {type === "secondary" && !isDownload && (
      <CustomSVG
        iconKey={"arrowRight"}
        className={animationStyles["circle-arrow-right"]}
        wrapper={"span"}
        width={28}
        height={28}
        aria-hidden={true}
      />
    )}

    {type === "primary" && (
      <CustomSVG
        iconKey={"bare_arrow_right"}
        className={animationStyles["leading-arrow"]}
        wrapper={"span"}
        width={20}
        height={20}
        aria-hidden={true}
      />
    )}

    {type === "secondary" && isDownload && (
      <CustomSVG
        iconKey={"download"}
        className={animationStyles["circle-arrow-right"]}
        wrapper={"span"}
        width={28}
        height={28}
        aria-hidden={true}
      />
    )}
  </>
);
